import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import {DefaultLanguage} from '@/plugins/i18n'
import discreteListEntiny from "@/plugins/store/discreteListEntiny";


const appModule = {
  namespaced: true,
  state: {
    isLoading: false,
    isInitialized: false,
    authenticated: false,
    locale: DefaultLanguage,
    rightsholders: {
      list: [],
      pagesLoaded: 0,
      finished: false,
    },

    currentRightsholderId: null,
    currentRightsholderData: null,
    notifications: discreteListEntiny(),
    notificationsPollingInterval: null,
  
    user: {},
    settings: {},

    statements: discreteListEntiny(),
    rights: discreteListEntiny(),
    unclaimed: discreteListEntiny(),
    staging: discreteListEntiny(),
    claimforms: discreteListEntiny(),

    homeContent: null,
    startContent: null,
    loginContent: null,
    documentContent: null,

    dialogContent: null,

  },
  getters,
  actions,
  mutations
}

export default appModule
